export const FINGERPRINT_PATHS = Array.from({ length: 18 }, (_, index) => {
  const radiusX = 37 + index * 5.6;
  const radiusY = 48 + index * 5.8;
  const start = 0.27 + (index % 4) * 0.045;
  const end = Math.PI * 2 - (0.25 + (index % 5) * 0.055);
  const points: string[] = [];
  for (let angle = start; angle <= end; angle += 0.035) {
    const x = 180 + radiusX * Math.cos(angle);
    const y = 179 + radiusY * Math.sin(angle);
    points.push(`${points.length ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`);
  }
  return { path: points.join(' '), opacity: 0.25 + index * 0.033 };
});
